import * as React from 'react';

const Tile = ({ instance, onSetFrame }) => (
  <div
    className='flex justify-center flex-col items-center'
    style={{
      height: '50px',
      width: '50px',
      flexDirection: 'column',
      marginRight: '30px',
      marginBottom: '30px',
      display: 'flex',
      ...instance.styles
    }}
    onClick={() => onSetFrame(instance)}
  >
    <div
      style={{
        height: '50px',
        width: '50px',
        border: '1px solid #1FAB24',
        borderRadius: '8px',
        ...instance.styles
      }}
    >
      <img
        style={{
          height: '50px',
          width: '50px',
          ...instance.imageStyles
        }}
        src={instance.image}
      />
    </div>
    <div
      style={{
        fontSize: '10px',
        fontWeight: '500',
        textAlign: 'center',
        whiteSpace: 'nowrap'
      }}
    >
      {instance.appName}
    </div>
  </div>
);

export default Tile;
